// 拼装家具
export default [
  {
    path: '/furniture',
    redirect: '/furniture/mesh',
  },

  // 零件
  {
    path: '/furniture/mesh',
    name: 'digital-mesh',
    component: () => import(/* webpackChunkName: "furniture" */ '@/views/digital/mesh/Index.vue'),
    meta: { title: '零件管理' },
  },
  {
    path: '/furniture/mesh/add',
    name: 'digital-mesh-add',
    component: () => import(/* webpackChunkName: "furniture" */ '@/views/digital/mesh/add/Add.vue'),
    meta: { title: '零件管理' },
  },
  {
    path: '/furniture/mesh/detail/:id',
    name: 'digital-mesh-detail',
    component: () => import(/* webpackChunkName: "furniture" */ '@/views/digital/mesh/detail/Index.vue'),
    meta: { title: '零件管理' },
  },
  {
    path: '/furniture/mesh/edit/:id',
    name: 'digital-mesh-edit',
    component: () => import(/* webpackChunkName: "furniture" */ '@/views/digital/mesh/edit/Edit.vue'),
    meta: { title: '零件管理' },
  },

  // 模块
  {
    path: '/furniture/block',
    name: 'digital-block',
    component: () => import(/* webpackChunkName: "furniture" */ '@/views/digital/block/Index.vue'),
    meta: { title: '模块管理' },
  },
  {
    path: '/furniture/block/detail/:id',
    name: 'digital-block-detail',
    component: () => import(/* webpackChunkName: "furniture" */ '@/views/digital/block/detail/Index.vue'),
    meta: { title: '模块管理' },
  },
  {
    path: '/furniture/block/edit/:id',
    name: 'digital-block-edit',
    component: () => import(/* webpackChunkName: "furniture" */ '@/views/digital/block/edit/Index.vue'),
    meta: { title: '模块管理' },
  },

  // 导航和检索
  {
    path: '/furniture/nav',
    name: 'digital-nav',
    component: () => import(/* webpackChunkName: "furniture" */ '@/views/digital/nav/Index.vue'),
    meta: { title: '家具导航' },
  },
  {
    path: '/furniture/search',
    name: 'digital-retrieval',
    component: () => import(/* webpackChunkName: "furniture" */ '@/views/digital/retrieval/Index.vue'),
    meta: { title: '家具检索' },
  },
];
